import React from 'react';
import { motion } from 'framer-motion';
import { mockData } from '../mock';

const Leadership = () => {
  return (
    <div className="min-h-screen pt-36 pb-20">
      <section className="border-b border-border bg-muted/30">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-3xl"
          >
            <p className="corporate-eyebrow mb-4">Governance</p>
            <h1 className="text-4xl md:text-5xl font-semibold mb-4">Our Leadership</h1>
            <p className="text-lg text-muted-foreground leading-relaxed">
              Meet the executives guiding AR Holdings toward a future of innovation, growth, and global impact.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {mockData.leadership.map((leader, index) => (
              <motion.div
                key={leader.name}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.08 }}
                className="corporate-card p-8 hover:border-[#B8941F]/40 hover:shadow-md transition-all duration-300"
              >
                <div className="flex items-start gap-6">
                  <div className="shrink-0">
                    <div className="w-20 h-20 bg-[#0B1F3A] flex items-center justify-center">
                      <span className="text-2xl font-semibold text-[#D4AF37]">
                        {leader.initials}
                      </span>
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-semibold mb-1">{leader.name}</h3>
                    <p className="text-[#B8941F] font-medium text-sm uppercase tracking-wide mb-4">
                      {leader.role}
                    </p>
                    <p className="text-muted-foreground leading-relaxed text-sm">
                      {leader.bio}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Leadership;
